export default "__VITE_ASSET__Dk43ZOk6__"